import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import * as Sync from 'ecosystem-marketplace-core/constants/dataSyncs/Sync';
// @ts-expect-error module is untyped
import { getDataSyncFilterI18nKey } from '../../../../utils/i18n';
const ALL = 'ALL';
const dataSyncsOrder = [ALL, Sync.INBOUND, Sync.OUTBOUND, Sync.BOTH];

function getDataSyncText(value) {
  const key = value === ALL ? 'appMarketplace.storefront.filters.planType.items.all' : getDataSyncFilterI18nKey(value);
  return unescapedText(key);
}

function getOptions() {
  return dataSyncsOrder.map(sync => ({
    text: getDataSyncText(sync),
    value: sync
  }));
}

function DataSyncDirectionFilter({
  onChange,
  value
}) {
  const options = useMemo(() => getOptions(), []);
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('appMarketplace.storefront.filters.sync.titleText'),
    name: "data-syncs",
    onChange: event => onChange(SyntheticEvent(event.target.value === ALL ? null : event.target.value, event)),
    options: options,
    value: value || ALL
  });
}

export default DataSyncDirectionFilter;